export default __webpack_public_path__ + "static/21_32-0aea1be514cd51538bba7ccc45bb8345.png";